import { useMemo } from 'react';

import type { ImageLoaderProps } from '@/utils/imageLoader';
import { createImageLoader, imageLoader } from '@/utils/imageLoader';

/**
 * Returns a Cloudflare image loader for use in React components.
 *
 * - `loader`: suitable as a Next.js `<Image loader={…} />` prop
 * - `load`: accepts the full ImageLoaderProps for imperative calls
 */
export const useImageLoader = () => {
  const loader = useMemo(() => createImageLoader(), []);

  const load = useMemo(
    () => (props: ImageLoaderProps) => imageLoader(props),
    [],
  );

  return { loader, load } as const;
};
